import { render, staticRenderFns } from "./MilestoneReasons.vue?vue&type=template&id=389302c2&"
import script from "./MilestoneReasons.vue?vue&type=script&lang=js&"
export * from "./MilestoneReasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports